import dayjs from "dayjs";

export const DateFormatter2 = (date) => {
  if (!date) {
    return "N/A";
  } else {
    return dayjs(date).format("DD MMMM, YYYY");
  }
};

export const DateFormatterDash = (date) => {
  if (!date) {
    return "N/A";
  } else {
    return dayjs(date).format("YYYY-MM-DD");
  }
};
